import type { EmailKeyUserRow, ExplainAccessInput } from './types';

export function emailKeyRowToExplainInput(row: EmailKeyUserRow): ExplainAccessInput {
  return {
    emailKey: row.emailKey,
    lifecycle: row.deleted ? 'deleted' : 'existing',
    authExists: row.authExists,
    authDisabled: row.authDisabled,
    emailVerified: row.emailVerified,
    invitedNotSignedIn: row.invitedNotSignedIn,
    grants: row.grants,
    activeSubscriptions: row.activeSubscriptions,
    lastSessionError: row.lastSessionError,
    lastSignInLinkSend: row.lastSignInLinkSend,
    knownUids: row.knownUids,
    fallbackLegacy: row.fallbackLegacy,
  };
}
